import React from 'react'
import { ResponsivePropClassNameMap, lit } from 'src/utils'
import { CardContext } from './CardContext'
import {
    AlignmentOption,
    buildResponsivePropDependentClassNames,
} from './shared'

export interface CardFooterProps {
    // specifies the tailwind class to use for `justify-content`,
    // e.g. 'justify-start' or 'justify-center'
    justifyContentClassName?: string
    className?: string
    children: React.ReactNode
}

const JUSTIFY_CLASSES: ResponsivePropClassNameMap<AlignmentOption> = {
    base: {
        start: 'justify-start',
        center: 'justify-center',
        end: 'justify-end',
    },
    '2xs': {
        start: '2xs:justify-start',
        center: '2xs:justify-center',
        end: '2xs:justify-end',
    },
    md: {
        start: 'md:justify-start',
        center: 'md:justify-center',
        end: 'md:justify-end',
    },
}

export function CardFooter({
    justifyContentClassName,
    className,
    children,
}: CardFooterProps) {
    const { align } = React.useContext(CardContext)
    const justifyClassName =
        justifyContentClassName ||
        buildResponsivePropDependentClassNames<AlignmentOption>(
            JUSTIFY_CLASSES,
            align
        )

    return (
        <footer
            className={lit`flex min-h-0 min-w-0 pt-8 ${justifyClassName} ${className}`}
        >
            {children}
        </footer>
    )
}
